import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {Glp1EducationFamilyBranded} from './Glp1EducationFamilyBranded';
import {Glp1EducationFamilyCompounded} from './Glp1EducationFamilyCompounded';

export const Glp1EducationFamily = () => {
  const modality = useGlp1Modality();
  return modality === 'compounded_v1' ? <Glp1EducationFamilyCompounded /> : <Glp1EducationFamilyBranded />;
};

export default Glp1EducationFamily;
